var $a0b4f895e1596b3b$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return n(r, t, e, a);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return function(u) {
                            return n(r, t, e, a, u);
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, a) {
        return 4 === n.a ? n.f(r, t, e, a) : n(r)(t)(e)(a);
    }
    function A5(n, r, t, e, a, u) {
        return 5 === n.a ? n.f(r, t, e, a, u) : n(r)(t)(e)(a)(u);
    }
    function t(n, r) {
        for(var t, a = [], u = e(n, r, 0, a); u && (t = a.pop()); u = e(t.a, t.b, 0, a));
        return u;
    }
    function e(n, r, t, a) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && h(5), !1;
        if (t > 100) return a.push(u(n, r)), !0;
        for(var i in 0 > n.$ && (n = Xn(n), r = Xn(r)), n)if (!e(n[i], r[i], t + 1, a)) return !1;
        return !0;
    }
    function a(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = a(n.a, r.a)) || (t = a(n.b, r.b)) ? t : a(n.c, r.c);
        for(; n.b && r.b && !(t = a(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    function u(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function i(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function o(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    function f(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = s(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = s(n.a, r);
        return t;
    }
    var c = {
        $: 0
    };
    function s(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var l = F2(s);
    function b(n) {
        for(var r = c, t = n.length; t--;)r = s(n[t], r);
        return r;
    }
    var d = F2(function(n, r) {
        return b((function(n) {
            for(var r = []; n.b; n = n.b)r.push(n.a);
            return r;
        })(r).sort(function(r, t) {
            return a(n(r), n(t));
        }));
    }), v = F3(function(n, r, t) {
        for(var e = Array(n), a = 0; n > a; a++)e[a] = t(r + a);
        return e;
    }), m = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, u(t, r);
    });
    function h(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    var g = Math.ceil, p = Math.floor, x = Math.log, y = F2(function(n, r) {
        return r.indexOf(n) > -1;
    });
    function $(n) {
        return {
            $: 2,
            b: n
        };
    }
    var S = $(function(n) {
        return "number" != typeof n ? R("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? ar(n) : !isFinite(n) || n % 1 ? R("an INT", n) : ar(n);
    }), w = ($(function(n) {
        return "boolean" == typeof n ? ar(n) : R("a BOOL", n);
    }), $(function(n) {
        return "number" == typeof n ? ar(n) : R("a FLOAT", n);
    }), $(function(n) {
        return ar(n);
    }), $(function(n) {
        return "string" == typeof n ? ar(n) : n instanceof String ? ar(n + "") : R("a STRING", n);
    })), A = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function M(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var C = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), N = F2(function(n, r) {
        return M(n, [
            r
        ]);
    }), B = F3(function(n, r, t) {
        return M(n, [
            r,
            t
        ]);
    }), T = F2(function(n, r) {
        return I(n, r);
    });
    function I(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? ar(n.c) : R("null", r);
            case 3:
                return G(r) ? k(n.b, r, b) : R("a LIST", r);
            case 4:
                return G(r) ? k(n.b, r, E) : R("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return R("an OBJECT with a field named `" + t + "`", r);
                var e = I(n.b, r[t]);
                return Gr(e) ? e : nr(A2(tr, t, e.a));
            case 7:
                var a = n.e;
                return G(r) ? r.length > a ? (e = I(n.b, r[a]), Gr(e) ? e : nr(A2(er, a, e.a))) : R("a LONGER array. Need index " + a + " but only see " + r.length + " entries", r) : R("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || G(r)) return R("an OBJECT", r);
                var i = c;
                for(var o in r)if (Object.prototype.hasOwnProperty.call(r, o)) {
                    if (e = I(n.b, r[o]), !Gr(e)) return nr(A2(tr, o, e.a));
                    i = s(u(o, e.a), i);
                }
                return ar(lr(i));
            case 9:
                for(var f = n.f, l = n.g, d = 0; l.length > d; d++){
                    if (e = I(l[d], r), !Gr(e)) return e;
                    f = f(e.a);
                }
                return ar(f);
            case 10:
                return e = I(n.b, r), Gr(e) ? I(n.h(e.a), r) : e;
            case 11:
                for(var v = c, m = n.g; m.b; m = m.b){
                    if (e = I(m.a, r), Gr(e)) return e;
                    v = s(e.a, v);
                }
                return nr(ur(lr(v)));
            case 1:
                return nr(A2(rr, n.a, r));
            case 0:
                return ar(n.a);
        }
    }
    function k(n, r, t) {
        for(var e = r.length, a = Array(e), u = 0; e > u; u++){
            var i = I(n, r[u]);
            if (!Gr(i)) return nr(A2(er, u, i.a));
            a[u] = i.a;
        }
        return ar(t(a));
    }
    function G(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function E(n) {
        return A2(kr, n.length, function(r) {
            return n[r];
        });
    }
    function R(n, r) {
        return nr(A2(rr, "Expecting " + n, r));
    }
    function L(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return L(n.b, r.b);
            case 6:
                return n.d === r.d && L(n.b, r.b);
            case 7:
                return n.e === r.e && L(n.b, r.b);
            case 9:
                return n.f === r.f && P(n.g, r.g);
            case 10:
                return n.h === r.h && L(n.b, r.b);
            case 11:
                return P(n.g, r.g);
        }
    }
    function P(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!L(n[e], r[e])) return !1;
        return !0;
    }
    function F(n) {
        return n;
    }
    function K(n) {
        return n;
    }
    function j(n) {
        return {
            $: 0,
            a: n
        };
    }
    function D(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var z = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), O = 0;
    function U(n) {
        var r = {
            $: 0,
            e: O++,
            f: n,
            g: null,
            h: []
        };
        return V(r), r;
    }
    function _(n, r) {
        n.h.push(r), V(n);
    }
    var H = !1, Z = [];
    function V(n) {
        if (Z.push(n), !H) {
            for(H = !0; n = Z.shift();)J(n);
            H = !1;
        }
    }
    function J(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, V(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var W = {};
    function Y(n, r, t, e, a) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: a
        };
    }
    function q(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, a = n.d, u = n.e, i = n.f;
        function o(n) {
            return A2(z, o, {
                $: 5,
                b: function(r) {
                    var o = r.a;
                    return 0 === r.$ ? A3(a, t, o, n) : u && i ? A4(e, t, o.i, o.j, n) : A3(e, t, u ? o.i : o.j, n);
                }
            });
        }
        return t.h = U(A2(z, o, n.b));
    }
    var Q = F2(function(n, r) {
        return D(function(t) {
            n.g(r), t(j(0));
        });
    });
    function X(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function nn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var rn = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    }), tn = [], en = !1;
    function an(n, r, t) {
        if (tn.push({
            p: n,
            q: r,
            r: t
        }), !en) {
            en = !0;
            for(var e; e = tn.shift();)un(e.p, e.q, e.r);
            en = !1;
        }
    }
    function un(n, r, t) {
        var e = {};
        for(var a in on(!0, r, e, null), on(!1, t, e, null), n)_(n[a], {
            $: "fx",
            a: e[a] || {
                i: c,
                j: c
            }
        });
    }
    function on(n, r, t, e) {
        switch(r.$){
            case 1:
                var a = r.k, u = function(n, r, t, e) {
                    function a(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? W[r].e : W[r].f, a, e);
                }(n, a, e, r.l);
                return void (t[a] = function(n, r, t) {
                    return t = t || {
                        i: c,
                        j: c
                    }, n ? t.i = s(r, t.i) : t.j = s(r, t.j), t;
                }(n, u, t[a]));
            case 2:
                for(var i = r.m; i.b; i = i.b)on(n, i.a, t, e);
                return;
            case 3:
                return void on(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    var fn = "undefined" != typeof document ? document : {};
    function cn(n, r) {
        n.appendChild(r);
    }
    function sn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var ln, bn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var a = [], u = 0; e.b; e = e.b){
                var i = e.a;
                u += i.b || 0, a.push(i);
            }
            return u += a.length, {
                $: 1,
                c: r,
                d: An(t),
                e: a,
                f: n,
                b: u
            };
        });
    }), dn = bn(void 0), vn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var a = [], u = 0; e.b; e = e.b){
                var i = e.a;
                u += i.b.b || 0, a.push(i);
            }
            return u += a.length, {
                $: 2,
                c: r,
                d: An(t),
                e: a,
                f: n,
                b: u
            };
        });
    })(void 0), mn = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), hn = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), gn = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    }), pn = /^script$/i, xn = /^(on|formAction$)/i, yn = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i, $n = F2(function(n, r) {
        return "a0" === r.$ ? A2(mn, r.n, function(n, r) {
            var t = Pr(r);
            return {
                $: r.$,
                a: t ? A3(Rr, 3 > t ? Sn : wn, Lr(n), r.a) : A2(Er, n, r.a)
            };
        }(n, r.o)) : r;
    }), Sn = F2(function(n, r) {
        return u(n(r.a), r.b);
    }), wn = F2(function(n, r) {
        return {
            I: n(r.I),
            aR: r.aR,
            aN: r.aN
        };
    });
    function An(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, a = t.n, u = t.o;
            if ("a2" !== e) {
                var i = r[e] || (r[e] = {});
                "a3" === e && "class" === a ? Mn(i, a, u) : i[a] = u;
            } else "className" === a ? Mn(r, a, K(u)) : r[a] = K(u);
        }
        return r;
    }
    function Mn(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function Cn(n, r) {
        var t = n.$;
        if (5 === t) return Cn(n.k || (n.k = n.m()), r);
        if (0 === t) return fn.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, a = n.j; 4 === e.$;)"object" != typeof a ? a = [
                a,
                e.j
            ] : a.push(e.j), e = e.k;
            var u = {
                j: a,
                p: r
            };
            return (i = Cn(e, u)).elm_event_node_ref = u, i;
        }
        if (3 === t) return Nn(i = n.h(n.g), r, n.d), i;
        var i = n.f ? fn.createElementNS(n.f, n.c) : fn.createElement(n.c);
        Nn(i, r, n.d);
        for(var o = n.e, f = 0; o.length > f; f++)cn(i, Cn(1 === t ? o[f] : o[f].b, r));
        return i;
    }
    function Nn(n, r, t) {
        for(var e in t){
            var a = t[e];
            "a1" === e ? Bn(n, a) : "a0" === e ? kn(n, r, a) : "a3" === e ? Tn(n, a) : "a4" === e ? In(n, a) : ("value" !== e && "checked" !== e || n[e] !== a) && (n[e] = a);
        }
    }
    function Bn(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function Tn(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function In(n, r) {
        for(var t in r){
            var e = r[t], a = e.f, u = e.o;
            void 0 !== u ? n.setAttributeNS(a, t, u) : n.removeAttributeNS(a, t);
        }
    }
    function kn(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var a in t){
            var u = t[a], i = e[a];
            if (u) {
                if (i) {
                    if (i.q.$ === u.$) {
                        i.q = u;
                        continue;
                    }
                    n.removeEventListener(a, i);
                }
                i = Gn(r, u), n.addEventListener(a, i, ln && {
                    passive: 2 > Pr(u)
                }), e[a] = i;
            } else n.removeEventListener(a, i), e[a] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                ln = !0;
            }
        }));
    } catch (n) {}
    function Gn(n, r) {
        function t(r) {
            var e = t.q, a = I(e.a, r);
            if (Gr(a)) {
                for(var u, i = Pr(e), o = a.a, f = i ? 3 > i ? o.a : o.I : o, c = 1 == i ? o.b : 3 == i && o.aR, s = (c && r.stopPropagation(), (2 == i ? o.b : 3 == i && o.aN) && r.preventDefault(), n); u = s.j;){
                    if ("function" == typeof u) f = u(f);
                    else for(var l = u.length; l--;)f = u[l](f);
                    s = s.p;
                }
                s(f, c);
            }
        }
        return t.q = r, t;
    }
    function En(n, r) {
        return n.$ == r.$ && L(n.a, r.a);
    }
    function Rn(n, r, t, e) {
        var a = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(a), a;
    }
    function Ln(n, r, t, e) {
        if (n !== r) {
            var a = n.$, u = r.$;
            if (a !== u) {
                if (1 !== a || 2 !== u) return void Rn(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), a = 0; t > a; a++)e[a] = r[a].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), u = 1;
            }
            switch(u){
                case 5:
                    for(var i = n.l, o = r.l, f = i.length, c = f === o.length; c && f--;)c = i[f] === o[f];
                    if (c) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return Ln(n.k, r.k, s, 0), void (s.length > 0 && Rn(t, 1, e, s));
                case 4:
                    for(var l = n.j, b = r.j, d = !1, v = n.k; 4 === v.$;)d = !0, "object" != typeof l ? l = [
                        l,
                        v.j
                    ] : l.push(v.j), v = v.k;
                    for(var m = r.k; 4 === m.$;)d = !0, "object" != typeof b ? b = [
                        b,
                        m.j
                    ] : b.push(m.j), m = m.k;
                    return d && l.length !== b.length ? void Rn(t, 0, e, r) : ((d ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(l, b) : l === b) || Rn(t, 2, e, b), void Ln(v, m, t, e + 1));
                case 0:
                    return void (n.a !== r.a && Rn(t, 3, e, r.a));
                case 1:
                    return void Pn(n, r, t, e, Kn);
                case 2:
                    return void Pn(n, r, t, e, jn);
                case 3:
                    if (n.h !== r.h) return void Rn(t, 0, e, r);
                    var h = Fn(n.d, r.d);
                    h && Rn(t, 4, e, h);
                    var g = r.i(n.g, r.g);
                    return void (g && Rn(t, 5, e, g));
            }
        }
    }
    function Pn(n, r, t, e, a) {
        if (n.c === r.c && n.f === r.f) {
            var u = Fn(n.d, r.d);
            u && Rn(t, 4, e, u), a(n, r, t, e);
        } else Rn(t, 0, e, r);
    }
    function Fn(n, r, t) {
        var e;
        for(var a in n)if ("a1" !== a && "a0" !== a && "a3" !== a && "a4" !== a) {
            if (a in r) {
                var u = n[a], i = r[a];
                u === i && "value" !== a && "checked" !== a || "a0" === t && En(u, i) || ((e = e || {})[a] = i);
            } else (e = e || {})[a] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[a].f,
                o: void 0
            } : "string" == typeof n[a] ? "" : null;
        } else {
            var o = Fn(n[a], r[a] || {}, a);
            o && ((e = e || {})[a] = o);
        }
        for(var f in r)f in n || ((e = e || {})[f] = r[f]);
        return e;
    }
    function Kn(n, r, t, e) {
        var a = n.e, u = r.e, i = a.length, o = u.length;
        i > o ? Rn(t, 6, e, {
            v: o,
            i: i - o
        }) : o > i && Rn(t, 7, e, {
            v: i,
            e: u
        });
        for(var f = o > i ? i : o, c = 0; f > c; c++){
            var s = a[c];
            Ln(s, u[c], t, ++e), e += s.b || 0;
        }
    }
    function jn(n, r, t, e) {
        for(var a = [], u = {}, i = [], o = n.e, f = r.e, c = o.length, s = f.length, l = 0, b = 0, d = e; c > l && s > b;){
            var v = (C = o[l]).a, m = (N = f[b]).a, h = C.b, g = N.b, p = void 0, x = void 0;
            if (v !== m) {
                var y = o[l + 1], $ = f[b + 1];
                if (y) {
                    var S = y.a, w = y.b;
                    x = m === S;
                }
                if ($) {
                    var A = $.a, M = $.b;
                    p = v === A;
                }
                if (p && x) Ln(h, M, a, ++d), zn(u, a, v, g, b, i), d += h.b || 0, On(u, a, v, w, ++d), d += w.b || 0, l += 2, b += 2;
                else if (p) d++, zn(u, a, m, g, b, i), Ln(h, M, a, d), d += h.b || 0, l += 1, b += 2;
                else if (x) On(u, a, v, h, ++d), d += h.b || 0, Ln(w, g, a, ++d), d += w.b || 0, l += 2, b += 1;
                else {
                    if (!y || S !== A) break;
                    On(u, a, v, h, ++d), zn(u, a, m, g, b, i), d += h.b || 0, Ln(w, M, a, ++d), d += w.b || 0, l += 2, b += 2;
                }
            } else Ln(h, g, a, ++d), d += h.b || 0, l++, b++;
        }
        for(; c > l;){
            var C;
            d++, On(u, a, (C = o[l]).a, h = C.b, d), d += h.b || 0, l++;
        }
        for(; s > b;){
            var N, B = B || [];
            zn(u, a, (N = f[b]).a, N.b, void 0, B), b++;
        }
        (a.length > 0 || i.length > 0 || B) && Rn(t, 8, e, {
            w: a,
            x: i,
            y: B
        });
    }
    var Dn = "_elmW6BL";
    function zn(n, r, t, e, a, u) {
        var i = n[t];
        if (!i) return u.push({
            r: a,
            A: i = {
                c: 0,
                z: e,
                r: a,
                s: void 0
            }
        }), void (n[t] = i);
        if (1 === i.c) {
            u.push({
                r: a,
                A: i
            }), i.c = 2;
            var o = [];
            return Ln(i.z, e, o, i.r), i.r = a, void (i.s.s = {
                w: o,
                A: i
            });
        }
        zn(n, r, t + Dn, e, a, u);
    }
    function On(n, r, t, e, a) {
        var u = n[t];
        if (u) {
            if (0 === u.c) {
                u.c = 2;
                var i = [];
                return Ln(e, u.z, i, a), void Rn(r, 9, a, {
                    w: i,
                    A: u
                });
            }
            On(n, r, t + Dn, e, a);
        } else {
            var o = Rn(r, 9, a, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: a,
                s: o
            };
        }
    }
    function Un(n, r, t, e) {
        _n(n, r, t, 0, 0, r.b, e);
    }
    function _n(n, r, t, e, a, u, i) {
        for(var o = t[e], f = o.r; f === a;){
            var c = o.$;
            if (1 === c) Un(n, r.k, o.s, i);
            else if (8 === c) o.t = n, o.u = i, (s = o.s.w).length > 0 && _n(n, r, s, 0, a, u, i);
            else if (9 === c) {
                o.t = n, o.u = i;
                var s, l = o.s;
                l && (l.A.s = n, (s = l.w).length > 0 && _n(n, r, s, 0, a, u, i));
            } else o.t = n, o.u = i;
            if (!(o = t[++e]) || (f = o.r) > u) return e;
        }
        var b = r.$;
        if (4 === b) {
            for(var d = r.k; 4 === d.$;)d = d.k;
            return _n(n, d, t, e, a + 1, u, n.elm_event_node_ref);
        }
        for(var v = r.e, m = n.childNodes, h = 0; v.length > h; h++){
            a++;
            var g = 1 === b ? v[h] : v[h].b, p = a + (g.b || 0);
            if (!(a > f || f > p || (o = t[e = _n(m[h], g, t, e, a, p, i)]) && (f = o.r) <= u)) return e;
            a = p;
        }
        return e;
    }
    function Hn(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], a = e.t, u = Zn(a, e);
            a === n && (n = u);
        }
        return n;
    }
    function Zn(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, a = Cn(r, t);
                    return a.elm_event_node_ref || (a.elm_event_node_ref = n.elm_event_node_ref), e && a !== n && e.replaceChild(a, n), a;
                }(n, r.s, r.u);
            case 4:
                return Nn(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Hn(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var a = (t = r.s).e, u = n.childNodes[e = t.v]; a.length > e; e++)n.insertBefore(Cn(a[e], r.u), u);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var i = t.A;
                return void 0 !== i.r && n.parentNode.removeChild(n), i.s = Hn(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = fn.createDocumentFragment(), e = 0; n.length > e; e++){
                                var a = n[e].A;
                                cn(t, 2 === a.c ? a.s : Cn(a.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = Hn(n, t.w);
                    for(var a = t.x, u = 0; a.length > u; u++){
                        var i = a[u], o = i.A, f = 2 === o.c ? o.s : Cn(o.z, r.u);
                        n.insertBefore(f, n.childNodes[i.r]);
                    }
                    return e && cn(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                h(10);
        }
    }
    function Vn(n) {
        if (3 === n.nodeType) return sn(n.textContent);
        if (1 !== n.nodeType) return sn("");
        for(var r = c, t = n.attributes, e = t.length; e--;){
            var a = t[e];
            r = s(A2(gn, a.name, a.value), r);
        }
        var u = n.tagName.toLowerCase(), i = c, o = n.childNodes;
        for(e = o.length; e--;)i = s(Vn(o[e]), i);
        return A3(dn, u, r, i);
    }
    var Jn = F4(function(n, r, t, e) {
        return function(n, r, t, e, a, u) {
            var i = A2(T, n, r ? r.flags : void 0);
            Gr(i) || h(2);
            var o = {}, f = t(i.a), c = f.a, s = u(b, c), l = function(n, r) {
                var t;
                for(var e in W){
                    var a = W[e];
                    a.a && ((t = t || {})[e] = a.a(e, r)), n[e] = q(a, r);
                }
                return t;
            }(o, b);
            function b(n, r) {
                var t = A2(e, n, c);
                s(c = t.a, r), an(o, t.b, a(c));
            }
            return an(o, f.b, a(c)), l ? {
                ports: l
            } : {};
        }(r, e, n.b4, n.cx, n.cr, function(r, t) {
            var a = n.cy, u = e.node, i = Vn(u);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (Wn(e), r(n), 1);
                }
                return function(a, u) {
                    n = a, u ? (r(n), 2 === t && (t = 1)) : (0 === t && Wn(e), t = 2);
                };
            }(t, function(n) {
                var t = a(n), e = function(n, r) {
                    var t = [];
                    return Ln(n, r, t, 0), t;
                }(i, t);
                u = function(n, r, t, e) {
                    return 0 === t.length ? n : (Un(n, r, t, e), Hn(n, t));
                }(u, i, e, r), i = t;
            });
        });
    }), Wn = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    "undefined" != typeof document && document, "undefined" != typeof window && window;
    var Yn = F2(function(n) {
        return n;
    }), qn = l, Qn = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, a = n, u = A3(n, t.b, t.c, A3(Qn, n, r, t.e));
            n = a, r = u, t = e;
        }
    }), Xn = function(n) {
        return A3(Qn, F3(function(n, r, t) {
            return A2(qn, u(n, r), t);
        }), c, n);
    }, nr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, rr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), tr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), er = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), ar = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ur = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ir = function(n) {
        return {
            $: 0,
            a: n
        };
    }, or = {
        $: 1
    }, fr = function(n) {
        return n + "";
    }, cr = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, a = n, u = A2(n, t.a, r);
            n = a, r = u, t = e;
        }
    }), sr = function(n) {
        return A3(cr, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, lr = function(n) {
        return A3(cr, qn, c, n);
    }, br = 32, dr = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), vr = [], mr = g, hr = F2(function(n, r) {
        return x(r) / x(n);
    }), gr = mr(A2(hr, 2, br)), pr = A4(dr, 0, gr, vr, vr), xr = v, yr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, $r = p, Sr = function(n) {
        return n.length;
    }, wr = F2(function(n, r) {
        return a(n, r) > 0 ? n : r;
    }), Ar = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Mr = m, Cr = F2(function(n, r) {
        for(;;){
            var t = A2(Mr, br, n), e = t.b, a = A2(qn, Ar(t.a), r);
            if (!e.b) return lr(a);
            n = e, r = a;
        }
    }), Nr = function(n) {
        return n.a;
    }, Br = F2(function(n, r) {
        for(;;){
            var t = mr(r / br);
            if (1 === t) return A2(Mr, br, n).a;
            n = A2(Cr, n, c), r = t;
        }
    }), Tr = F2(function(n, r) {
        if (r.f) {
            var t = r.f * br, e = $r(A2(hr, br, t - 1)), a = n ? lr(r.j) : r.j, u = A2(Br, a, r.f);
            return A4(dr, Sr(r.i) + t, A2(wr, 5, e * gr), u, r.i);
        }
        return A4(dr, Sr(r.i), gr, vr, r.i);
    }), Ir = F5(function(n, r, t, e, a) {
        for(;;){
            if (0 > r) return A2(Tr, !1, {
                j: e,
                f: t / br | 0,
                i: a
            });
            var u = yr(A3(xr, br, r, n));
            r -= br, e = A2(qn, u, e);
        }
    }), kr = F2(function(n, r) {
        if (n > 0) {
            var t = n % br;
            return A5(Ir, r, n - t - br, n, c, A3(xr, t, n - t, r));
        }
        return pr;
    }), Gr = function(n) {
        return !n.$;
    }, Er = N, Rr = B, Lr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Pr = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, Fr = function(n) {
        return n;
    }, Kr = y, jr = j, Dr = jr(0), zr = F4(function(n, r, t, e) {
        if (e.b) {
            var a = e.a, u = e.b;
            if (u.b) {
                var i = u.a, o = u.b;
                if (o.b) {
                    var f = o.a, c = o.b;
                    if (c.b) {
                        var s = c.b;
                        return A2(n, a, A2(n, i, A2(n, f, A2(n, c.a, t > 500 ? A3(cr, n, r, lr(s)) : A4(zr, n, r, t + 1, s)))));
                    }
                    return A2(n, a, A2(n, i, A2(n, f, r)));
                }
                return A2(n, a, A2(n, i, r));
            }
            return A2(n, a, r);
        }
        return r;
    }), Or = F3(function(n, r, t) {
        return A4(zr, n, r, 0, t);
    }), Ur = F2(function(n, r) {
        return A3(Or, F2(function(r, t) {
            return A2(qn, n(r), t);
        }), c, r);
    }), _r = z, Hr = F2(function(n, r) {
        return A2(_r, function(r) {
            return jr(n(r));
        }, r);
    }), Zr = F3(function(n, r, t) {
        return A2(_r, function(r) {
            return A2(_r, function(t) {
                return jr(A2(n, r, t));
            }, t);
        }, r);
    }), Vr = Q, Jr = F2(function(n, r) {
        var t = r;
        return function(n) {
            return D(function(r) {
                r(j(U(n)));
            });
        }(A2(_r, Vr(n), t));
    });
    W.Task = Y(Dr, F3(function(n, r) {
        var t;
        return A2(Hr, function() {
            return 0;
        }, (t = A2(Ur, Jr(n), r), A3(Or, Zr(qn), jr(c), t)));
    }), F3(function() {
        return jr(0);
    }), F2(function(n, r) {
        return A2(Hr, n, r);
    }));
    var Wr, Yr = X("Task"), qr = F2(function(n, r) {
        return Yr(A2(Hr, n, r));
    }), Qr = Jn, Xr = {
        $: 0
    }, nt = nn, rt = nt(c), tt = nn(c), et = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), at = F3(function(n, r, t) {
        return {
            aF: n,
            av: t,
            aO: r
        };
    }), ut = {
        $: 1
    }, it = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), ot = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), ft = F4(function(n, r, t, e) {
        return {
            af: n,
            ah: r,
            Z: e,
            K: t
        };
    }), ct = function(n) {
        return {
            $: 2,
            a: n
        };
    }, st = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), lt = function(n) {
        return D(function(r) {
            var t = setTimeout(function() {
                r(j(0));
            }, n);
            return function() {
                clearTimeout(t);
            };
        });
    }, bt = F2(function(n, r) {
        return A2(qr, Yn(r), lt(n));
    }), dt = function(n) {
        return {
            $: 2,
            a: n
        };
    }, vt = F2(function(n, r) {
        switch(r.$){
            case 0:
                return c;
            case 1:
                return b([
                    A2(bt, r.a, A2(st, 2, n))
                ]);
            default:
                return b([
                    A2(bt, r.a, dt(n))
                ]);
        }
    }), mt = F2(function(n, r) {
        return u(r, nt(n));
    }), ht = F2(function(n, r) {
        var t, e = n.as, a = f(n.E, b([
            o(r, {
                bb: e
            })
        ]));
        return A2(mt, A2(qn, A2(bt, 100, A2(st, 1, e)), A2(vt, e, r.aw)), o(n, {
            as: (t = e, t + 1),
            E: a
        }));
    }), gt = F2(function(n, r) {
        return A2(ht, n, r);
    }), pt = F3(function(n, r, t) {
        return {
            aE: r,
            a4: t,
            aK: n
        };
    }), xt = A2(Ur, function(n) {
        return A3(pt, n.a, n.b, n.c);
    }, b([
        i("Andorra", "AD", "\uD83C\uDDE6\uD83C\uDDE9"),
        i("United Arab Emirates", "AE", "\uD83C\uDDE6\uD83C\uDDEA"),
        i("Afghanistan", "AF", "\uD83C\uDDE6\uD83C\uDDEB"),
        i("Antigua and Barbuda", "AG", "\uD83C\uDDE6\uD83C\uDDEC"),
        i("Anguilla", "AI", "\uD83C\uDDE6\uD83C\uDDEE"),
        i("Albania", "AL", "\uD83C\uDDE6\uD83C\uDDF1"),
        i("Armenia", "AM", "\uD83C\uDDE6\uD83C\uDDF2"),
        i("Angola", "AO", "\uD83C\uDDE6\uD83C\uDDF4"),
        i("Antarctica", "AQ", "\uD83C\uDDE6\uD83C\uDDF6"),
        i("Argentina", "AR", "\uD83C\uDDE6\uD83C\uDDF7"),
        i("American Samoa", "AS", "\uD83C\uDDE6\uD83C\uDDF8"),
        i("Austria", "AT", "\uD83C\uDDE6\uD83C\uDDF9"),
        i("Australia", "AU", "\uD83C\uDDE6\uD83C\uDDFA"),
        i("Aruba", "AW", "\uD83C\uDDE6\uD83C\uDDFC"),
        i("\xc5land Islands", "AX", "\uD83C\uDDE6\uD83C\uDDFD"),
        i("Azerbaijan", "AZ", "\uD83C\uDDE6\uD83C\uDDFF"),
        i("Bosnia and Herzegovina", "BA", "\uD83C\uDDE7\uD83C\uDDE6"),
        i("Barbados", "BB", "\uD83C\uDDE7\uD83C\uDDE7"),
        i("Bangladesh", "BD", "\uD83C\uDDE7\uD83C\uDDE9"),
        i("Belgium", "BE", "\uD83C\uDDE7\uD83C\uDDEA"),
        i("Burkina Faso", "BF", "\uD83C\uDDE7\uD83C\uDDEB"),
        i("Bulgaria", "BG", "\uD83C\uDDE7\uD83C\uDDEC"),
        i("Bahrain", "BH", "\uD83C\uDDE7\uD83C\uDDED"),
        i("Burundi", "BI", "\uD83C\uDDE7\uD83C\uDDEE"),
        i("Benin", "BJ", "\uD83C\uDDE7\uD83C\uDDEF"),
        i("Saint Barth\xe9lemy", "BL", "\uD83C\uDDE7\uD83C\uDDF1"),
        i("Bermuda", "BM", "\uD83C\uDDE7\uD83C\uDDF2"),
        i("Brunei Darussalam", "BN", "\uD83C\uDDE7\uD83C\uDDF3"),
        i("Bolivia (Plurinational State of)", "BO", "\uD83C\uDDE7\uD83C\uDDF4"),
        i("Bonaire, Sint Eustatius and Saba", "BQ", "\uD83C\uDDE7\uD83C\uDDF6"),
        i("Brazil", "BR", "\uD83C\uDDE7\uD83C\uDDF7"),
        i("Bahamas", "BS", "\uD83C\uDDE7\uD83C\uDDF8"),
        i("Bhutan", "BT", "\uD83C\uDDE7\uD83C\uDDF9"),
        i("Bouvet Island", "BV", "\uD83C\uDDE7\uD83C\uDDFB"),
        i("Botswana", "BW", "\uD83C\uDDE7\uD83C\uDDFC"),
        i("Belarus", "BY", "\uD83C\uDDE7\uD83C\uDDFE"),
        i("Belize", "BZ", "\uD83C\uDDE7\uD83C\uDDFF"),
        i("Canada", "CA", "\uD83C\uDDE8\uD83C\uDDE6"),
        i("Cocos (Keeling) Islands", "CC", "\uD83C\uDDE8\uD83C\uDDE8"),
        i("Congo, Democratic Republic of the", "CD", "\uD83C\uDDE8\uD83C\uDDE9"),
        i("Central African Republic", "CF", "\uD83C\uDDE8\uD83C\uDDEB"),
        i("Congo", "CG", "\uD83C\uDDE8\uD83C\uDDEC"),
        i("Switzerland", "CH", "\uD83C\uDDE8\uD83C\uDDED"),
        i("C\xf4te d'Ivoire", "CI", "\uD83C\uDDE8\uD83C\uDDEE"),
        i("Cook Islands", "CK", "\uD83C\uDDE8\uD83C\uDDF0"),
        i("Chile", "CL", "\uD83C\uDDE8\uD83C\uDDF1"),
        i("Cameroon", "CM", "\uD83C\uDDE8\uD83C\uDDF2"),
        i("China", "CN", "\uD83C\uDDE8\uD83C\uDDF3"),
        i("Colombia", "CO", "\uD83C\uDDE8\uD83C\uDDF4"),
        i("Costa Rica", "CR", "\uD83C\uDDE8\uD83C\uDDF7"),
        i("Cuba", "CU", "\uD83C\uDDE8\uD83C\uDDFA"),
        i("Cabo Verde", "CV", "\uD83C\uDDE8\uD83C\uDDFB"),
        i("Cura\xe7ao", "CW", "\uD83C\uDDE8\uD83C\uDDFC"),
        i("Christmas Island", "CX", "\uD83C\uDDE8\uD83C\uDDFD"),
        i("Cyprus", "CY", "\uD83C\uDDE8\uD83C\uDDFE"),
        i("Czechia", "CZ", "\uD83C\uDDE8\uD83C\uDDFF"),
        i("Germany", "DE", "\uD83C\uDDE9\uD83C\uDDEA"),
        i("Djibouti", "DJ", "\uD83C\uDDE9\uD83C\uDDEF"),
        i("Denmark", "DK", "\uD83C\uDDE9\uD83C\uDDF0"),
        i("Dominica", "DM", "\uD83C\uDDE9\uD83C\uDDF2"),
        i("Dominican Republic", "DO", "\uD83C\uDDE9\uD83C\uDDF4"),
        i("Algeria", "DZ", "\uD83C\uDDE9\uD83C\uDDFF"),
        i("Ecuador", "EC", "\uD83C\uDDEA\uD83C\uDDE8"),
        i("Estonia", "EE", "\uD83C\uDDEA\uD83C\uDDEA"),
        i("Egypt", "EG", "\uD83C\uDDEA\uD83C\uDDEC"),
        i("Western Sahara", "EH", "\uD83C\uDDEA\uD83C\uDDED"),
        i("Eritrea", "ER", "\uD83C\uDDEA\uD83C\uDDF7"),
        i("Spain", "ES", "\uD83C\uDDEA\uD83C\uDDF8"),
        i("Ethiopia", "ET", "\uD83C\uDDEA\uD83C\uDDF9"),
        i("Finland", "FI", "\uD83C\uDDEB\uD83C\uDDEE"),
        i("Fiji", "FJ", "\uD83C\uDDEB\uD83C\uDDEF"),
        i("Falkland Islands (Malvinas)", "FK", "\uD83C\uDDEB\uD83C\uDDF0"),
        i("Micronesia (Federated States of)", "FM", "\uD83C\uDDEB\uD83C\uDDF2"),
        i("Faroe Islands", "FO", "\uD83C\uDDEB\uD83C\uDDF4"),
        i("France", "FR", "\uD83C\uDDEB\uD83C\uDDF7"),
        i("Gabon", "GA", "\uD83C\uDDEC\uD83C\uDDE6"),
        i("United Kingdom of Great Britain and Northern Ireland", "GB", "\uD83C\uDDEC\uD83C\uDDE7"),
        i("Grenada", "GD", "\uD83C\uDDEC\uD83C\uDDE9"),
        i("Georgia", "GE", "\uD83C\uDDEC\uD83C\uDDEA"),
        i("French Guiana", "GF", "\uD83C\uDDEC\uD83C\uDDEB"),
        i("Guernsey", "GG", "\uD83C\uDDEC\uD83C\uDDEC"),
        i("Ghana", "GH", "\uD83C\uDDEC\uD83C\uDDED"),
        i("Gibraltar", "GI", "\uD83C\uDDEC\uD83C\uDDEE"),
        i("Greenland", "GL", "\uD83C\uDDEC\uD83C\uDDF1"),
        i("Gambia", "GM", "\uD83C\uDDEC\uD83C\uDDF2"),
        i("Guinea", "GN", "\uD83C\uDDEC\uD83C\uDDF3"),
        i("Guadeloupe", "GP", "\uD83C\uDDEC\uD83C\uDDF5"),
        i("Equatorial Guinea", "GQ", "\uD83C\uDDEC\uD83C\uDDF6"),
        i("Greece", "GR", "\uD83C\uDDEC\uD83C\uDDF7"),
        i("South Georgia and the South Sandwich Islands", "GS", "\uD83C\uDDEC\uD83C\uDDF8"),
        i("Guatemala", "GT", "\uD83C\uDDEC\uD83C\uDDF9"),
        i("Guam", "GU", "\uD83C\uDDEC\uD83C\uDDFA"),
        i("Guinea-Bissau", "GW", "\uD83C\uDDEC\uD83C\uDDFC"),
        i("Guyana", "GY", "\uD83C\uDDEC\uD83C\uDDFE"),
        i("Hong Kong", "HK", "\uD83C\uDDED\uD83C\uDDF0"),
        i("Heard Island and McDonald Islands", "HM", "\uD83C\uDDED\uD83C\uDDF2"),
        i("Honduras", "HN", "\uD83C\uDDED\uD83C\uDDF3"),
        i("Croatia", "HR", "\uD83C\uDDED\uD83C\uDDF7"),
        i("Haiti", "HT", "\uD83C\uDDED\uD83C\uDDF9"),
        i("Hungary", "HU", "\uD83C\uDDED\uD83C\uDDFA"),
        i("Indonesia", "ID", "\uD83C\uDDEE\uD83C\uDDE9"),
        i("Ireland", "IE", "\uD83C\uDDEE\uD83C\uDDEA"),
        i("Israel", "IL", "\uD83C\uDDEE\uD83C\uDDF1"),
        i("Isle of Man", "IM", "\uD83C\uDDEE\uD83C\uDDF2"),
        i("India", "IN", "\uD83C\uDDEE\uD83C\uDDF3"),
        i("British Indian Ocean Territory", "IO", "\uD83C\uDDEE\uD83C\uDDF4"),
        i("Iraq", "IQ", "\uD83C\uDDEE\uD83C\uDDF6"),
        i("Iran (Islamic Republic of)", "IR", "\uD83C\uDDEE\uD83C\uDDF7"),
        i("Iceland", "IS", "\uD83C\uDDEE\uD83C\uDDF8"),
        i("Italy", "IT", "\uD83C\uDDEE\uD83C\uDDF9"),
        i("Jersey", "JE", "\uD83C\uDDEF\uD83C\uDDEA"),
        i("Jamaica", "JM", "\uD83C\uDDEF\uD83C\uDDF2"),
        i("Jordan", "JO", "\uD83C\uDDEF\uD83C\uDDF4"),
        i("Japan", "JP", "\uD83C\uDDEF\uD83C\uDDF5"),
        i("Kenya", "KE", "\uD83C\uDDF0\uD83C\uDDEA"),
        i("Kyrgyzstan", "KG", "\uD83C\uDDF0\uD83C\uDDEC"),
        i("Cambodia", "KH", "\uD83C\uDDF0\uD83C\uDDED"),
        i("Kiribati", "KI", "\uD83C\uDDF0\uD83C\uDDEE"),
        i("Comoros", "KM", "\uD83C\uDDF0\uD83C\uDDF2"),
        i("Saint Kitts and Nevis", "KN", "\uD83C\uDDF0\uD83C\uDDF3"),
        i("Korea (Democratic People's Republic of)", "KP", "\uD83C\uDDF0\uD83C\uDDF5"),
        i("Korea, Republic of", "KR", "\uD83C\uDDF0\uD83C\uDDF7"),
        i("Kuwait", "KW", "\uD83C\uDDF0\uD83C\uDDFC"),
        i("Cayman Islands", "KY", "\uD83C\uDDF0\uD83C\uDDFE"),
        i("Kazakhstan", "KZ", "\uD83C\uDDF0\uD83C\uDDFF"),
        i("Lao People's Democratic Republic", "LA", "\uD83C\uDDF1\uD83C\uDDE6"),
        i("Lebanon", "LB", "\uD83C\uDDF1\uD83C\uDDE7"),
        i("Saint Lucia", "LC", "\uD83C\uDDF1\uD83C\uDDE8"),
        i("Liechtenstein", "LI", "\uD83C\uDDF1\uD83C\uDDEE"),
        i("Sri Lanka", "LK", "\uD83C\uDDF1\uD83C\uDDF0"),
        i("Liberia", "LR", "\uD83C\uDDF1\uD83C\uDDF7"),
        i("Lesotho", "LS", "\uD83C\uDDF1\uD83C\uDDF8"),
        i("Lithuania", "LT", "\uD83C\uDDF1\uD83C\uDDF9"),
        i("Luxembourg", "LU", "\uD83C\uDDF1\uD83C\uDDFA"),
        i("Latvia", "LV", "\uD83C\uDDF1\uD83C\uDDFB"),
        i("Libya", "LY", "\uD83C\uDDF1\uD83C\uDDFE"),
        i("Morocco", "MA", "\uD83C\uDDF2\uD83C\uDDE6"),
        i("Monaco", "MC", "\uD83C\uDDF2\uD83C\uDDE8"),
        i("Moldova, Republic of", "MD", "\uD83C\uDDF2\uD83C\uDDE9"),
        i("Montenegro", "ME", "\uD83C\uDDF2\uD83C\uDDEA"),
        i("Saint Martin (French part)", "MF", "\uD83C\uDDF2\uD83C\uDDEB"),
        i("Madagascar", "MG", "\uD83C\uDDF2\uD83C\uDDEC"),
        i("Marshall Islands", "MH", "\uD83C\uDDF2\uD83C\uDDED"),
        i("North Macedonia", "MK", "\uD83C\uDDF2\uD83C\uDDF0"),
        i("Mali", "ML", "\uD83C\uDDF2\uD83C\uDDF1"),
        i("Myanmar", "MM", "\uD83C\uDDF2\uD83C\uDDF2"),
        i("Mongolia", "MN", "\uD83C\uDDF2\uD83C\uDDF3"),
        i("Macao", "MO", "\uD83C\uDDF2\uD83C\uDDF4"),
        i("Northern Mariana Islands", "MP", "\uD83C\uDDF2\uD83C\uDDF5"),
        i("Martinique", "MQ", "\uD83C\uDDF2\uD83C\uDDF6"),
        i("Mauritania", "MR", "\uD83C\uDDF2\uD83C\uDDF7"),
        i("Montserrat", "MS", "\uD83C\uDDF2\uD83C\uDDF8"),
        i("Malta", "MT", "\uD83C\uDDF2\uD83C\uDDF9"),
        i("Mauritius", "MU", "\uD83C\uDDF2\uD83C\uDDFA"),
        i("Maldives", "MV", "\uD83C\uDDF2\uD83C\uDDFB"),
        i("Malawi", "MW", "\uD83C\uDDF2\uD83C\uDDFC"),
        i("Mexico", "MX", "\uD83C\uDDF2\uD83C\uDDFD"),
        i("Malaysia", "MY", "\uD83C\uDDF2\uD83C\uDDFE"),
        i("Mozambique", "MZ", "\uD83C\uDDF2\uD83C\uDDFF"),
        i("Namibia", "NA", "\uD83C\uDDF3\uD83C\uDDE6"),
        i("New Caledonia", "NC", "\uD83C\uDDF3\uD83C\uDDE8"),
        i("Niger", "NE", "\uD83C\uDDF3\uD83C\uDDEA"),
        i("Norfolk Island", "NF", "\uD83C\uDDF3\uD83C\uDDEB"),
        i("Nigeria", "NG", "\uD83C\uDDF3\uD83C\uDDEC"),
        i("Nicaragua", "NI", "\uD83C\uDDF3\uD83C\uDDEE"),
        i("Netherlands", "NL", "\uD83C\uDDF3\uD83C\uDDF1"),
        i("Norway", "NO", "\uD83C\uDDF3\uD83C\uDDF4"),
        i("Nepal", "NP", "\uD83C\uDDF3\uD83C\uDDF5"),
        i("Nauru", "NR", "\uD83C\uDDF3\uD83C\uDDF7"),
        i("Niue", "NU", "\uD83C\uDDF3\uD83C\uDDFA"),
        i("New Zealand", "NZ", "\uD83C\uDDF3\uD83C\uDDFF"),
        i("Oman", "OM", "\uD83C\uDDF4\uD83C\uDDF2"),
        i("Panama", "PA", "\uD83C\uDDF5\uD83C\uDDE6"),
        i("Peru", "PE", "\uD83C\uDDF5\uD83C\uDDEA"),
        i("French Polynesia", "PF", "\uD83C\uDDF5\uD83C\uDDEB"),
        i("Papua New Guinea", "PG", "\uD83C\uDDF5\uD83C\uDDEC"),
        i("Philippines", "PH", "\uD83C\uDDF5\uD83C\uDDED"),
        i("Pakistan", "PK", "\uD83C\uDDF5\uD83C\uDDF0"),
        i("Poland", "PL", "\uD83C\uDDF5\uD83C\uDDF1"),
        i("Saint Pierre and Miquelon", "PM", "\uD83C\uDDF5\uD83C\uDDF2"),
        i("Pitcairn", "PN", "\uD83C\uDDF5\uD83C\uDDF3"),
        i("Puerto Rico", "PR", "\uD83C\uDDF5\uD83C\uDDF7"),
        i("Palestine, State of", "PS", "\uD83C\uDDF5\uD83C\uDDF8"),
        i("Portugal", "PT", "\uD83C\uDDF5\uD83C\uDDF9"),
        i("Palau", "PW", "\uD83C\uDDF5\uD83C\uDDFC"),
        i("Paraguay", "PY", "\uD83C\uDDF5\uD83C\uDDFE"),
        i("Qatar", "QA", "\uD83C\uDDF6\uD83C\uDDE6"),
        i("R\xe9union", "RE", "\uD83C\uDDF7\uD83C\uDDEA"),
        i("Romania", "RO", "\uD83C\uDDF7\uD83C\uDDF4"),
        i("Serbia", "RS", "\uD83C\uDDF7\uD83C\uDDF8"),
        i("Russian Federation", "RU", "\uD83C\uDDF7\uD83C\uDDFA"),
        i("Rwanda", "RW", "\uD83C\uDDF7\uD83C\uDDFC"),
        i("Saudi Arabia", "SA", "\uD83C\uDDF8\uD83C\uDDE6"),
        i("Solomon Islands", "SB", "\uD83C\uDDF8\uD83C\uDDE7"),
        i("Seychelles", "SC", "\uD83C\uDDF8\uD83C\uDDE8"),
        i("Sudan", "SD", "\uD83C\uDDF8\uD83C\uDDE9"),
        i("Sweden", "SE", "\uD83C\uDDF8\uD83C\uDDEA"),
        i("Singapore", "SG", "\uD83C\uDDF8\uD83C\uDDEC"),
        i("Saint Helena, Ascension and Tristan da Cunha", "SH", "\uD83C\uDDF8\uD83C\uDDED"),
        i("Slovenia", "SI", "\uD83C\uDDF8\uD83C\uDDEE"),
        i("Svalbard and Jan Mayen", "SJ", "\uD83C\uDDF8\uD83C\uDDEF"),
        i("Slovakia", "SK", "\uD83C\uDDF8\uD83C\uDDF0"),
        i("Sierra Leone", "SL", "\uD83C\uDDF8\uD83C\uDDF1"),
        i("San Marino", "SM", "\uD83C\uDDF8\uD83C\uDDF2"),
        i("Senegal", "SN", "\uD83C\uDDF8\uD83C\uDDF3"),
        i("Somalia", "SO", "\uD83C\uDDF8\uD83C\uDDF4"),
        i("Suriname", "SR", "\uD83C\uDDF8\uD83C\uDDF7"),
        i("South Sudan", "SS", "\uD83C\uDDF8\uD83C\uDDF8"),
        i("Sao Tome and Principe", "ST", "\uD83C\uDDF8\uD83C\uDDF9"),
        i("El Salvador", "SV", "\uD83C\uDDF8\uD83C\uDDFB"),
        i("Sint Maarten (Dutch part)", "SX", "\uD83C\uDDF8\uD83C\uDDFD"),
        i("Syrian Arab Republic", "SY", "\uD83C\uDDF8\uD83C\uDDFE"),
        i("Eswatini", "SZ", "\uD83C\uDDF8\uD83C\uDDFF"),
        i("Turks and Caicos Islands", "TC", "\uD83C\uDDF9\uD83C\uDDE8"),
        i("Chad", "TD", "\uD83C\uDDF9\uD83C\uDDE9"),
        i("French Southern Territories", "TF", "\uD83C\uDDF9\uD83C\uDDEB"),
        i("Togo", "TG", "\uD83C\uDDF9\uD83C\uDDEC"),
        i("Thailand", "TH", "\uD83C\uDDF9\uD83C\uDDED"),
        i("Tajikistan", "TJ", "\uD83C\uDDF9\uD83C\uDDEF"),
        i("Tokelau", "TK", "\uD83C\uDDF9\uD83C\uDDF0"),
        i("Timor-Leste", "TL", "\uD83C\uDDF9\uD83C\uDDF1"),
        i("Turkmenistan", "TM", "\uD83C\uDDF9\uD83C\uDDF2"),
        i("Tunisia", "TN", "\uD83C\uDDF9\uD83C\uDDF3"),
        i("Tonga", "TO", "\uD83C\uDDF9\uD83C\uDDF4"),
        i("Turkey", "TR", "\uD83C\uDDF9\uD83C\uDDF7"),
        i("Trinidad and Tobago", "TT", "\uD83C\uDDF9\uD83C\uDDF9"),
        i("Tuvalu", "TV", "\uD83C\uDDF9\uD83C\uDDFB"),
        i("Taiwan, Province of China", "TW", "\uD83C\uDDF9\uD83C\uDDFC"),
        i("Tanzania, United Republic of", "TZ", "\uD83C\uDDF9\uD83C\uDDFF"),
        i("Ukraine", "UA", "\uD83C\uDDFA\uD83C\uDDE6"),
        i("Uganda", "UG", "\uD83C\uDDFA\uD83C\uDDEC"),
        i("United States Minor Outlying Islands", "UM", "\uD83C\uDDFA\uD83C\uDDF2"),
        i("United States of America", "US", "\uD83C\uDDFA\uD83C\uDDF8"),
        i("Uruguay", "UY", "\uD83C\uDDFA\uD83C\uDDFE"),
        i("Uzbekistan", "UZ", "\uD83C\uDDFA\uD83C\uDDFF"),
        i("Holy See", "VA", "\uD83C\uDDFB\uD83C\uDDE6"),
        i("Saint Vincent and the Grenadines", "VC", "\uD83C\uDDFB\uD83C\uDDE8"),
        i("Venezuela (Bolivarian Republic of)", "VE", "\uD83C\uDDFB\uD83C\uDDEA"),
        i("Virgin Islands (British)", "VG", "\uD83C\uDDFB\uD83C\uDDEC"),
        i("Virgin Islands (U.S.)", "VI", "\uD83C\uDDFB\uD83C\uDDEE"),
        i("Viet Nam", "VN", "\uD83C\uDDFB\uD83C\uDDF3"),
        i("Vanuatu", "VU", "\uD83C\uDDFB\uD83C\uDDFA"),
        i("Wallis and Futuna", "WF", "\uD83C\uDDFC\uD83C\uDDEB"),
        i("Samoa", "WS", "\uD83C\uDDFC\uD83C\uDDF8"),
        i("Yemen", "YE", "\uD83C\uDDFE\uD83C\uDDEA"),
        i("Mayotte", "YT", "\uD83C\uDDFE\uD83C\uDDF9"),
        i("South Africa", "ZA", "\uD83C\uDDFF\uD83C\uDDE6"),
        i("Zambia", "ZM", "\uD83C\uDDFF\uD83C\uDDF2"),
        i("Zimbabwe", "ZW", "\uD83C\uDDFF\uD83C\uDDFC")
    ])), yt = function(n) {
        return n.b;
    }, $t = {
        as: 0,
        E: c
    }, St = F2(function(n, r) {
        return {
            N: 0,
            bT: r,
            at: 0,
            bb: -1,
            B: 1,
            aw: n,
            D: 0
        };
    }), wt = function(n) {
        return St({
            $: 1,
            a: n
        });
    }, At = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Mt = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Ct = function(n) {
        var r = n.b;
        return A2(Mt, 1664525 * n.a + r >>> 0, r);
    }, Nt = (Wr = Fr, D(function(n) {
        n(j(Wr(Date.now())));
    })), Bt = A2(_r, function(n) {
        var r, t;
        return jr((r = n, t = Ct(A2(Mt, 0, 1013904223)), Ct(A2(Mt, t.a + r >>> 0, t.b))));
    }, Nt), Tt = F2(function(n, r) {
        return n(r);
    }), It = F3(function(n, r, t) {
        if (r.b) {
            var e = r.b, a = A2(Tt, r.a, t), u = a.b;
            return A2(_r, function() {
                return A3(It, n, e, u);
            }, A2(Vr, n, a.a));
        }
        return jr(t);
    }), kt = F3(function(n, r, t) {
        return jr(t);
    }), Gt = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r), a = e.b;
            return u(n(e.a), a);
        };
    });
    W.Random = Y(Bt, It, kt, F2(function(n, r) {
        return A2(Gt, n, r);
    }));
    var Et, Rt = X("Random"), Lt = F2(function(n, r) {
        return Rt(A2(Gt, n, r));
    }), Pt = rn, Ft = function(n) {
        var r = n.a, t = 277803737 * (r ^ r >>> (r >>> 28) + 4);
        return (t >>> 22 ^ t) >>> 0;
    }, Kt = F2(function(n, r) {
        return function(t) {
            var e = 0 > a(n, r) ? u(n, r) : u(r, n), i = e.a, o = e.b - i + 1;
            if (o - 1 & o) {
                var f = (-o >>> 0) % o >>> 0;
                return function(n) {
                    for(;;){
                        var r = Ft(n), t = Ct(n);
                        if (a(r, f) >= 0) return u(r % o + i, t);
                        n = t;
                    }
                }(t);
            }
            return u(((o - 1 & Ft(t)) >>> 0) + i, Ct(t));
        };
    }), jt = A2(Kt, -2147483648, 2147483647), Dt = F4(function(n, r, t, e) {
        var a = r, i = t, o = e;
        return function(r) {
            var t = a(r), e = t.a, f = i(t.b), c = f.a, s = o(f.b), l = s.b;
            return u(A3(n, e, c, s.a), l);
        };
    }), zt = function(n) {
        var r = F3(function(n, r, t) {
            return Ct(A2(Mt, n, (1 | r ^ t) >>> 0));
        }), t = A2(Kt, 0, 4294967295);
        return A2(Tt, A4(Dt, r, t, t, t), n);
    }, Ot = function(n) {
        return n.b;
    }, Ut = d, _t = F3(function(n, r, t) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var e = r.a;
                    n -= 1, r = r.b, t = A2(qn, e, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), Ht = F2(function(n, r) {
        return lr(A3(_t, n, r, c));
    }), Zt = F3(function(n, r, t) {
        if (r > 0) {
            var e = u(r, t);
            n: for(;;){
                r: for(;;){
                    if (!e.b.b) return t;
                    if (!e.b.b.b) {
                        if (1 === e.a) break n;
                        break r;
                    }
                    switch(e.a){
                        case 1:
                            break n;
                        case 2:
                            var a = e.b;
                            return b([
                                a.a,
                                a.b.a
                            ]);
                        case 3:
                            if (e.b.b.b.b) {
                                var i = e.b, o = i.b;
                                return b([
                                    i.a,
                                    o.a,
                                    o.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (e.b.b.b.b && e.b.b.b.b.b) {
                                var f = e.b, s = f.b, l = s.b, d = l.b, v = d.b;
                                return A2(qn, f.a, A2(qn, s.a, A2(qn, l.a, A2(qn, d.a, n > 1e3 ? A2(Ht, r - 4, v) : A3(Zt, n + 1, r - 4, v)))));
                            }
                            break r;
                    }
                }
                return t;
            }
            return b([
                e.b.a
            ]);
        }
        return c;
    }), Vt = F2(function(n, r) {
        return A3(Zt, 0, n, r);
    }), Jt = function(n) {
        return n.toLowerCase();
    }, Wt = function(n) {
        return n.trim();
    }, Yt = function(n) {
        return A2(mt, function(n) {
            var r = n.aw;
            return 2 === r.$ ? b([
                A2(bt, r.a, dt(n.bb))
            ]) : c;
        }(n), o(n, {
            N: n.N + 1,
            B: 1
        }));
    }, qt = function(n) {
        return u(n, rt);
    }, Qt = function(n) {
        return !n.B || n.N > 0 ? qt(o(n, {
            N: n.N - 1
        })) : u(n, A2(qr, Fr, jr(A2(st, 2, n.bb))));
    }, Xt = function(n) {
        return u(o(n, {
            D: 2
        }), A2(bt, n.at, {
            $: 3,
            a: n.bb
        }));
    }, ne = F2(function(n, r) {
        return A3(Or, F2(function(r, t) {
            return n(r) ? A2(qn, r, t) : t;
        }), c, r);
    }), re = F2(function(n, r) {
        return o(n, {
            E: r
        });
    }), te = F2(function(n, r) {
        return qt(A2(re, r, A2(ne, function(r) {
            return !t(r.bb, n);
        }, r.E)));
    }), ee = F3(function(n, r, t) {
        return r(n(t));
    }), ae = F3(function(n, r, t) {
        n: for(;;){
            if (t.b) {
                var e = t.a, a = t.b, i = n(e);
                if (i.$) {
                    r = A2(qn, e, r), t = a;
                    continue n;
                }
                var o = i.a, c = o.a, s = o.b;
                return u(f(lr(r), A2(qn, c, a)), ir(s));
            }
            return u(lr(r), or);
        }
    }), ue = F3(function(n, r, t) {
        var e = t.b;
        return u(n(t.a), r(e));
    }), ie = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), oe = F3(function(n, r, e) {
        var a = function(e) {
            return t(e.bb, r) ? ir(n(e)) : or;
        };
        return A3(ue, re(e), ie(rt), A3(ae, a, c, e.E));
    }), fe = function(n) {
        return oe(A2(ee, n, qt));
    }, ce = function(n) {
        switch(n.$){
            case 0:
                switch(n.a){
                    case 1:
                        return A2(fe, function(n) {
                            return o(n, {
                                D: 1
                            });
                        }, n.b);
                    case 0:
                        return A2(fe, function(n) {
                            return o(n, {
                                D: 0
                            });
                        }, n.b);
                    default:
                        return A2(oe, Xt, n.b);
                }
            case 1:
                return n.a ? A2(oe, Yt, n.b) : A2(fe, function(n) {
                    return o(n, {
                        B: 0
                    });
                }, n.b);
            case 2:
                return A2(oe, Qt, n.a);
            default:
                return te(n.a);
        }
    }, se = F2(function(n, r) {
        var t = r.b;
        return u(n(r.a), t);
    }), le = F2(function(n, r) {
        return A2(se, Fr, A2(ce, n, r));
    }), be = F3(function(n, r, t) {
        var e, a;
        return a = (e = A2(le, r, t)).b, u(n(e.a), A2(Pt, ct, a));
    }), de = F2(function(n, r) {
        switch(n.$){
            case 3:
                return u(A2(it, n.a, 1 === r.$ ? d = r.b : $t), rt);
            case 0:
                var t = n.a, e = A2(Gt, function(n) {
                    switch(t){
                        case 0:
                            return n;
                        case 1:
                            return A2(Vt, 50, n);
                        default:
                            return A2(Vt, 100, n);
                    }
                }, (S = xt, A2(Gt, function(n) {
                    return A2(Ur, Nr, A2(Ut, Ot, A3(cr, F2(function(n, r) {
                        var t = r.a, e = A2(Tt, jt, r.b), a = e.b;
                        return u(A2(qn, u(n, e.a), t), a);
                    }), u(c, n), S).a));
                }, zt)));
                return u(r, A2(Lt, ot(A4(ft, 0, 0, 0, 0)), e));
            case 1:
                return u(Xr, rt);
            case 2:
                var a = n.a;
                switch(r.$){
                    case 1:
                        var i = r.b;
                        return A3(be, it(r.a), a, i);
                    case 2:
                        return i = r.b, A3(be, et(f = r.a), a, i);
                    default:
                        return u(r, rt);
                }
            case 5:
                var f = n.a, s = ($ = l = n.b).b ? ir(A3(At, c, $.a, $.b)) : or;
                return u(s.$ ? A2(et, f, $t) : A2(it, A3(at, s.a, f, ""), $t), rt);
            default:
                var l = n.a.aF, b = (f = n.a.aO, n.a.av), d = n.b, v = Wt(b).length >= 3 && A2(Kr, Jt(Wt(b)), Jt(yt(l).aK)), m = v ? ut : {
                    $: 0,
                    a: yt(l).aK
                }, h = o(f, v ? {
                    af: f.af + 1,
                    Z: A2(wr, f.K + 1, f.Z),
                    K: f.K + 1
                } : {
                    ah: f.ah + 1,
                    K: 0
                }), g = A2(gt, d, A2(wt, 2e3, m)), p = g.a, x = g.b;
                return u((y = function(n) {
                    var r = n.c;
                    if (r.b) {
                        var t = r.a, e = r.b;
                        return ir(A3(At, A2(qn, n.b, n.a), t, e));
                    }
                    return or;
                }(l)).$ ? A2(et, h, p) : A2(it, A3(at, y.a, h, ""), p), A2(Pt, ct, x));
        }
        var y, $, S;
    }), ve = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), me = {
        $: 1
    }, he = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ge = dn("a"), pe = F2(function(n, r) {
        return A2(gn, function(n) {
            return xn.test(n) ? "data-" + n : n;
        }(n), function(n) {
            return yn.test(n) ? "" : n;
        }(r));
    }), xe = F, ye = F2(function(n, r) {
        return A2(hn, n, xe(r));
    }), $e = F, Se = F2(function(n, r) {
        return A2(hn, n, $e(r));
    })("autofocus"), we = function(n) {
        return lr(n.a);
    }, Ae = dn("button"), Me = ye("className"), Ce = function(n) {
        return {
            O: c,
            P: c,
            ai: c,
            aU: n,
            ao: c,
            ap: c,
            aC: "div"
        };
    }, Ne = dn("div"), Be = dn("h1"), Te = dn("h2"), Ie = dn("h3"), ke = dn("input"), Ge = function(n) {
        return 1 === n.$;
    }, Ee = mn, Re = F2(function(n, r) {
        return A2(Ee, n, {
            $: 0,
            a: r
        });
    }), Le = function(n) {
        return A2(Re, "click", Lr(n));
    }, Pe = C, Fe = A, Ke = A2(Fe, "keyCode", S), je = function(n) {
        return u(n, !0);
    }, De = F2(function(n, r) {
        return A2(Ee, n, {
            $: 1,
            a: r
        });
    }), ze = w, Oe = A2(F2(function(n, r) {
        return A3(Or, Fe, r, n);
    }), b([
        "target",
        "value"
    ]), ze), Ue = dn("p"), _e = ye("placeholder"), He = function(n) {
        return vn(function(n) {
            return pn.test(n) ? "p" : n;
        }(n));
    }, Ze = F2(function(n, r) {
        return r.b ? A3(Or, qn, r, n) : n;
    }), Ve = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Je = $n, We = function(n) {
        return Ur(Je(n));
    }, Ye = function(n) {
        return A2(Re, "blur", Lr(n));
    }, qe = function(n) {
        return A2(Re, "focus", Lr(n));
    }, Qe = function(n) {
        return A2(Re, "mouseleave", Lr(n));
    }, Xe = F2(function(n, r) {
        var t;
        return A2(We, n, b([
            A2(gn, "tabIndex", fr(0)),
            (t = A2(Ve, 0, r), A2(Re, "mouseenter", Lr(t))),
            Qe(A2(Ve, 1, r)),
            qe(A2(Ve, 0, r)),
            Ye(A2(Ve, 1, r))
        ]));
    }), na = F2(function(n, r) {
        return r ? c : n.ai;
    }), ra = F2(function(n, r) {
        switch(r){
            case 0:
                return n.O;
            case 1:
                return c;
            default:
                return n.P;
        }
    }), ta = F2(function(n, r) {
        var t;
        return t = b([
            n.ao,
            A2(na, n, r.B),
            A2(ra, n, r.D),
            A2(Xe, n.aU, r.bb)
        ]), A3(Or, Ze, c, t);
    }), ea = F3(function(n, r, t) {
        return u("toast-" + fr(t.bb), A2(n, A2(ta, r, t), function(n) {
            return {
                bT: n.bT,
                bb: n.bb,
                B: n.B,
                D: n.D
            };
        }(t)));
    }), aa = F3(function(n, r, t) {
        var e = r;
        return A3(He, t.aC, t.ap, A2(Ur, A2(ea, n, t), e.E));
    }), ua = dn("span"), ia = sn, oa = ye("title"), fa = ye("type"), ca = ye("value"), sa = gn("class"), la = gn("d"), ba = st(2), da = gn("fill"), va = bn("http://www.w3.org/2000/svg"), ma = va("path"), ha = gn("stroke-linecap"), ga = gn("stroke-linejoin"), pa = gn("stroke-width"), xa = va("svg"), ya = gn("viewBox"), $a = F2(function(n, r) {
        return A2(Ne, n, function() {
            var n = r.bT;
            if (n.$) return b([
                A2(Ne, b([
                    A2(pe, "role", "alert"),
                    Me("alert alert-success animate-in slide-in-from-top duration-500 animate-out slide-out-to-top  mb-2.5"),
                    Le(ct(ba(r.bb)))
                ]), b([
                    A2(xa, b([
                        sa("h-6 w-6 shrink-0 stroke-current animate-bounce"),
                        da("none"),
                        ya("0 0 24 24")
                    ]), b([
                        A2(ma, b([
                            ha("round"),
                            ga("round"),
                            pa("2"),
                            la("M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z")
                        ]), c)
                    ])),
                    A2(ua, b([
                        Me("animate-in fade-in duration-300")
                    ]), b([
                        ia("Correct!")
                    ]))
                ]))
            ]);
            var t = n.a;
            return b([
                A2(Ne, b([
                    A2(pe, "role", "alert"),
                    Me("alert alert-error animate-in slide-in-from-top duration-500 animate-out slide-out-to-top mb-2.5"),
                    Le(ct(ba(r.bb)))
                ]), b([
                    A2(xa, b([
                        sa("h-6 w-6 shrink-0 stroke-current animate-pulse"),
                        da("none"),
                        ya("0 0 24 24")
                    ]), b([
                        A2(ma, b([
                            ha("round"),
                            ga("round"),
                            pa("2"),
                            la("M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z")
                        ]), c)
                    ])),
                    A2(ua, b([
                        Me("animate-in fade-in duration-300")
                    ]), b([
                        ia("Mistake! The country was: " + t)
                    ]))
                ]))
            ]);
        }());
    });
    Et = {
        Main: {
            init: Qr({
                b4: function() {
                    return u(Xr, rt);
                },
                cr: Yn(tt),
                cx: de,
                cy: function(n) {
                    return A2(Ne, b([
                        Me("min-h-screen flex flex-col bg-base-200")
                    ]), b([
                        A2(Ne, b([
                            Me("navbar bg-base-100 shadow-md sticky top-0 z-50")
                        ]), b([
                            A2(Ne, b([
                                Me("flex-1")
                            ]), b([
                                A2(ge, b([
                                    Me("btn btn-ghost text-lg md:text-xl normal-case")
                                ]), b([
                                    ia("\uD83C\uDF0D Countries Quiz")
                                ]))
                            ])),
                            A2(Ne, b([
                                Me("flex-none")
                            ]), Ge(n) ? b([
                                A2(Ae, b([
                                    Me("btn btn-ghost btn-sm md:btn-md"),
                                    Le(me)
                                ]), b([
                                    ia("\uD83D\uDD04 Restart")
                                ]))
                            ]) : c)
                        ])),
                        A2(Ne, b([
                            Me("flex-1 flex items-center justify-center p-4 md:p-8")
                        ]), function() {
                            switch(n.$){
                                case 0:
                                    return b([
                                        A2(Ne, b([
                                            Me("text-center space-y-6 animate-in fade-in zoom-in duration-700")
                                        ]), b([
                                            A2(Be, b([
                                                Me("text-4xl md:text-6xl font-bold mb-4")
                                            ]), b([
                                                ia("Flag Quiz")
                                            ])),
                                            A2(Ue, b([
                                                Me("text-lg md:text-xl text-base-content/70 mb-8")
                                            ]), b([
                                                ia(" \uD83E\uDDE0 Can you guess all the countries? \uD83C\uDF0D")
                                            ])),
                                            A2(Ne, b([
                                                Me("flex flex-col gap-3 items-center")
                                            ]), b([
                                                A2(Ae, b([
                                                    Me("btn btn-primary btn-lg btn-wide text-lg"),
                                                    Le(he(0))
                                                ]), b([
                                                    ia("\uD83D\uDE80 All Countries")
                                                ])),
                                                A2(Ae, b([
                                                    Me("btn btn-secondary btn-lg btn-wide text-lg"),
                                                    Le(he(1))
                                                ]), b([
                                                    ia("\uD83C\uDFB2 Random 50")
                                                ])),
                                                A2(Ae, b([
                                                    Me("btn btn-accent btn-lg btn-wide text-lg"),
                                                    Le(he(2))
                                                ]), b([
                                                    ia("\uD83C\uDFAF Random 100")
                                                ]))
                                            ]))
                                        ]))
                                    ]);
                                case 1:
                                    var r = n.a, t = r.aF, e = r.aO, a = r.av, u = n.b;
                                    return b([
                                        A2(Ne, b([
                                            Me("toast toast-top toast-center z-50")
                                        ]), b([
                                            A3(aa, $a, u, Ce(ct))
                                        ])),
                                        A2(Ne, b([
                                            Me("w-full max-w-4xl mx-auto flex flex-col gap-4 md:gap-6")
                                        ]), b([
                                            A2(Ne, b([
                                                Me("sticky top-16 z-40 bg-base-200 pb-2 md:relative md:top-0 md:order-2")
                                            ]), b([
                                                A2(ke, b([
                                                    fa("text"),
                                                    _e("Type country name..."),
                                                    Me("input input-bordered input-lg w-full text-lg md:text-xl focus:input-primary shadow-lg"),
                                                    A2(ye, "autocomplete", "off"),
                                                    Se(!0),
                                                    A2(pe, "autocapitalize", "words"),
                                                    (m = function(n) {
                                                        return {
                                                            $: 3,
                                                            a: o(r, {
                                                                av: n
                                                            })
                                                        };
                                                    }, A2(De, "input", A2(Er, je, A2(Er, m, Oe)))),
                                                    ca(a),
                                                    (v = A2(ve, r, u), A2(Re, "keyup", A2(Pe, function(n) {
                                                        return 13 === n ? Lr(v) : {
                                                            $: 1,
                                                            a: fr(n)
                                                        };
                                                    }, Ke)))
                                                ]), c)
                                            ])),
                                            A2(Ne, b([
                                                Me("card bg-base-100 shadow-xl md:order-1")
                                            ]), b([
                                                A2(Ne, b([
                                                    Me("card-body flex items-center justify-center py-8 md:py-16")
                                                ]), b([
                                                    A2(Te, b([
                                                        Me("text-7xl md:text-9xl text-center select-none")
                                                    ]), b([
                                                        ia(yt(t).a4)
                                                    ]))
                                                ]))
                                            ])),
                                            A2(Ne, b([
                                                Me("stats stats-vertical sm:stats-horizontal bg-base-100 shadow-xl w-full md:order-3")
                                            ]), b([
                                                A2(Ne, b([
                                                    Me("stat place-items-center py-2")
                                                ]), b([
                                                    A2(Ne, b([
                                                        Me("stat-title text-xs")
                                                    ]), b([
                                                        ia("Correct")
                                                    ])),
                                                    A2(Ne, b([
                                                        Me("stat-value text-success text-xl md:text-4xl transition-all duration-300")
                                                    ]), b([
                                                        ia("\u2705 " + fr(e.af))
                                                    ]))
                                                ])),
                                                A2(Ne, b([
                                                    Me("stat place-items-center py-2")
                                                ]), b([
                                                    A2(Ne, b([
                                                        Me("stat-title text-xs")
                                                    ]), b([
                                                        ia("Incorrect")
                                                    ])),
                                                    A2(Ne, b([
                                                        Me("stat-value text-error text-xl md:text-4xl transition-all duration-300")
                                                    ]), b([
                                                        ia("\u274C " + fr(e.ah))
                                                    ]))
                                                ])),
                                                A2(Ne, b([
                                                    Me("stat place-items-center py-2")
                                                ]), b([
                                                    A2(Ne, b([
                                                        Me("stat-title text-xs")
                                                    ]), b([
                                                        ia("Streak")
                                                    ])),
                                                    A2(Ne, b([
                                                        Me("stat-value text-primary text-xl md:text-4xl transition-all duration-300 " + (e.K > 0 ? "animate-pulse scale-110" : ""))
                                                    ]), b([
                                                        ia(f(e.K > 2 ? "\uD83D\uDD25 " : "", fr(e.K)))
                                                    ]))
                                                ])),
                                                A2(Ne, b([
                                                    Me("stat place-items-center py-2")
                                                ]), b([
                                                    A2(Ne, b([
                                                        Me("stat-title text-xs")
                                                    ]), b([
                                                        ia("Best")
                                                    ])),
                                                    A2(Ne, b([
                                                        Me("stat-value text-secondary text-xl md:text-4xl transition-all duration-500")
                                                    ]), b([
                                                        ia(f(e.Z > 2 ? "\uD83D\uDD25 " : "", fr(e.Z)))
                                                    ]))
                                                ]))
                                            ])),
                                            (d = we(t), d.b ? A2(Ne, b([
                                                Me("card bg-base-100 shadow-lg animate-in fade-in duration-500 md:order-4")
                                            ]), b([
                                                A2(Ne, b([
                                                    Me("card-body p-4")
                                                ]), b([
                                                    A2(Ie, b([
                                                        Me("text-sm font-semibold text-center opacity-60 mb-2")
                                                    ]), b([
                                                        ia("Guessed: " + fr(sr(we(t))))
                                                    ])),
                                                    A2(Ne, b([
                                                        Me("flex flex-wrap gap-2 justify-center")
                                                    ]), A2(Ur, function(n) {
                                                        return A2(ua, b([
                                                            Me("text-3xl md:text-4xl line-through opacity-50 hover:opacity-80 transition-opacity animate-in zoom-in duration-300"),
                                                            oa(n.aK)
                                                        ]), b([
                                                            ia(n.a4)
                                                        ]));
                                                    }, lr(we(t))))
                                                ]))
                                            ])) : ia(""))
                                        ]))
                                    ]);
                                default:
                                    var i = n.a.af, s = n.a.ah, l = n.a.Z;
                                    return u = n.b, b([
                                        A2(Ne, b([
                                            Me("toast toast-top toast-center z-50")
                                        ]), b([
                                            A3(aa, $a, u, Ce(ct))
                                        ])),
                                        A2(Ne, b([
                                            Me("card w-full max-w-md bg-base-100 shadow-2xl animate-in zoom-in duration-500")
                                        ]), b([
                                            A2(Ne, b([
                                                Me("card-body p-6 md:p-8")
                                            ]), b([
                                                A2(Te, b([
                                                    Me("card-title text-2xl md:text-4xl text-center justify-center mb-6 animate-in slide-in-from-top duration-700")
                                                ]), b([
                                                    ia("Congratulations! \uD83C\uDF89")
                                                ])),
                                                A2(Ne, b([
                                                    Me("stats stats-vertical shadow w-full mb-4")
                                                ]), b([
                                                    A2(Ne, b([
                                                        Me("stat animate-in slide-in-from-left duration-500 delay-200")
                                                    ]), b([
                                                        A2(Ne, b([
                                                            Me("stat-figure text-success")
                                                        ]), b([
                                                            A2(Ne, b([
                                                                Me("text-4xl")
                                                            ]), b([
                                                                ia("\u2705")
                                                            ]))
                                                        ])),
                                                        A2(Ne, b([
                                                            Me("stat-title")
                                                        ]), b([
                                                            ia("Correct")
                                                        ])),
                                                        A2(Ne, b([
                                                            Me("stat-value text-success")
                                                        ]), b([
                                                            ia(fr(i))
                                                        ]))
                                                    ])),
                                                    A2(Ne, b([
                                                        Me("stat animate-in slide-in-from-right duration-500 delay-300")
                                                    ]), b([
                                                        A2(Ne, b([
                                                            Me("stat-figure text-error")
                                                        ]), b([
                                                            A2(Ne, b([
                                                                Me("text-4xl")
                                                            ]), b([
                                                                ia("\u274C")
                                                            ]))
                                                        ])),
                                                        A2(Ne, b([
                                                            Me("stat-title")
                                                        ]), b([
                                                            ia("Incorrect")
                                                        ])),
                                                        A2(Ne, b([
                                                            Me("stat-value text-error")
                                                        ]), b([
                                                            ia(fr(s))
                                                        ]))
                                                    ])),
                                                    A2(Ne, b([
                                                        Me("stat animate-in slide-in-from-bottom duration-500 delay-400")
                                                    ]), b([
                                                        A2(Ne, b([
                                                            Me("stat-figure text-warning")
                                                        ]), b([
                                                            A2(Ne, b([
                                                                Me("text-4xl animate-pulse")
                                                            ]), b([
                                                                ia("\uD83D\uDD25")
                                                            ]))
                                                        ])),
                                                        A2(Ne, b([
                                                            Me("stat-title")
                                                        ]), b([
                                                            ia("Best Streak")
                                                        ])),
                                                        A2(Ne, b([
                                                            Me("stat-value text-warning")
                                                        ]), b([
                                                            ia(fr(l))
                                                        ]))
                                                    ]))
                                                ])),
                                                A2(Ne, b([
                                                    Me("card-actions justify-center mt-4")
                                                ]), b([
                                                    A2(Ae, b([
                                                        Me("btn btn-primary btn-wide"),
                                                        Le(me)
                                                    ]), b([
                                                        ia("\uD83D\uDE80 Play Again")
                                                    ]))
                                                ]))
                                            ]))
                                        ]))
                                    ]);
                            }
                            var d, v, m;
                        }())
                    ]));
                }
            })(Lr(0))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? h(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, Et) : n.Elm = Et;
}($a0b4f895e1596b3b$exports);


(0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    node: document.getElementById("root")
});


//# sourceMappingURL=repo.3be474e7.js.map
